module.exports = __webpack_public_path__ + "./images/yellowmap.e84c60.svg";